<div class="manage-entity-container">

  <!-- TITLEBAR -->
  <section class="manage-entity-titlebar">
    <div class="manage-entity-titlebar-left">
      <h3>Entity Visualization {{ selectedProjectModel?.name ? ' for ' + selectedProjectModel?.name + ' Entity' : '' }}
      </h3>
      <p>
        Generate and customize how your data entities are visualized and interacted with in the AI assistant and
        database entity viewers
      </p>
    </div>
    <div class="manage-entity-titlebar-right">
      <!-- Test Button
      <rappider-button text="Test"
                       type="default"
                       size="small"
                       tooltipText="Test Button"
                       [icon]="{ name: 'fa-regular fa-star' }"
                       customCssClass="canvas-title-button"
                       (confirm)="onCanvasButtonClicked($event)">
      </rappider-button>
      -->
    </div>

  </section>

  <!-- TOOLBAR -->
  <section class="manage-entity-toolbar">
    <rappider-button text="Show All"
                     [type]="getToolbarButtonType('allViews')"
                     [size]="ButtonSize.Small"
                     [icon]="{ name: 'fa-regular fa-image-stack' }"
                     (confirm)="onToolbarButtonClicked('allViews')">
    </rappider-button>
    <rappider-button text="Item View"
                     [type]="getToolbarButtonType('itemView')"
                     [size]="ButtonSize.Small"
                     [icon]="{ name: 'fa-regular fa-image' }"
                     (confirm)="onToolbarButtonClicked('itemView')">
    </rappider-button>
    <rappider-button text="Grid View"
                     [type]="getToolbarButtonType('gridView')"
                     [size]="ButtonSize.Small"
                     [icon]="{ name: 'fa-regular fa-table-list' }"
                     (confirm)="onToolbarButtonClicked('gridView')">
    </rappider-button>
    <rappider-button text="Card View"
                     [type]="getToolbarButtonType('cardView')"
                     [size]="ButtonSize.Small"
                     [icon]="{ name: 'fa-regular fa-grid-2' }"
                     (confirm)="onToolbarButtonClicked('cardView')">
    </rappider-button>
    <rappider-button text="Item Data View"
                     [type]="getToolbarButtonType('itemDataView')"
                     [size]="ButtonSize.Small"
                     [icon]="{ name: 'fa-regular fa-table' }"
                     (confirm)="onToolbarButtonClicked('itemDataView')">
    </rappider-button>
    <rappider-button text="Edit View"
                     [type]="getToolbarButtonType('itemEditView')"
                     [size]="ButtonSize.Small"
                     [icon]="{ name: 'fa-regular fa-square-pen' }"
                     (confirm)="onToolbarButtonClicked('itemEditView')">
    </rappider-button>
    <rappider-button text="Create View"
                     [type]="getToolbarButtonType('itemCreateView')"
                     [size]="ButtonSize.Small"
                     [icon]="{ name: 'fa-regular fa-square-plus' }"
                     (confirm)="onToolbarButtonClicked('itemCreateView')">
    </rappider-button>
    <rappider-button text="Schema"
                     [type]="getToolbarButtonType('schemaView')"
                     [size]="ButtonSize.Small"
                     [icon]="{ name: 'fa-regular fa-database' }"
                     (confirm)="onToolbarButtonClicked('schemaView')">
    </rappider-button>
  </section>


  <!-- CONTENT -->
  <div class="manage-entity-content-container">
    <div class="manage-entity-content-infobar">
      <div class="info-box">
        <i class="fa-regular fa-circle-info info-icon"></i> &nbsp; Click sections below to expand/collapse or use the
        buttons on the toolbar to view specific sections.
      </div>
      <div *ngIf="displayedSection === 'all'">
        <rappider-button [text]="expandAllSections ? 'Collapse All' : 'Expand All'"
                         [type]="ButtonType.Default"
                         [size]="ButtonSize.Small"
                         [icon]="{ name: expandAllSections ? 'fa-regular fa-caret-up' : 'fa-regular fa-caret-down' }"
                         (confirm)="expandAllSections = !expandAllSections">
        </rappider-button>
      </div>

    </div>
    <!-- CUSTOM COMPONENT -->
    <nz-collapse *ngIf="displayedSection === 'all' || displayedSection === 'itemView'"
                 class="manage-entity-collapse"
                 [nzBordered]="true"
                 [nzExpandIconPosition]="'right'">

      <nz-collapse-panel class="manage-entity-collapse-panel"
                         [nzActive]="expandAllSections || displayedSection === 'itemView' || (displayedSection === 'all' && isFirstPanelExpanded)"
                         [nzDisabled]="displayedSection !== 'all'"
                         nzGhost
                         [nzHeader]="nzCollapseHeader0">

        <ng-template #nzCollapseHeader0>
          <ng-container *ngTemplateOutlet="nzCollapseHeader;
                          context:{
                            title: 'Entity Visualization',
                            description: 'Create or select a component to visualize and interact with individual items of this entity. This will be used in the AI assistant and other detailed views.',
                            key: entityConfig?.config?.displayWithComponent ? 'customComponent' : undefined
                          }"></ng-container>
        </ng-template>

        <!-- Component Renderer (if display component exists) -->
        <ng-container *ngIf="hasDisplayComponent(); else noComponentTemplate">
          <section>
          <div class="component-renderer-header">
            <button class="configure-component-button"
                    nz-button
                    nzType="primary"
                    nz-tooltip
                    nzTooltipTitle="Configure Component Settings"
                    (click)="onConfigureComponentClick()">
                    <i class="fa-regular fa-gear"></i>
                    Configure Component
            </button>
          </div>
          <div class="component-renderer-box">
            <rappider-compiled-component-renderer [componentType]="'flutter'"
                                                  [hideActionButtons]="false"
                                                  [allowDisplayingInputData]="true"
                                                  [allowReRendering]="true"
                                                  [allowReRendering]="true"
                                                  [allowSourceCodeEditing]="true"
                                                  [viewOnly]="false"
                                                  [componentDefinition]="{
                bundleUrl: getDisplayComponentBundleUrl(),
                id: getDisplayComponentDefinitionId()
              }"
                                                  [component]="{
                id: 'entity_component_' + selectedProjectModel?.id + '_' + getDisplayComponentDefinitionId()
              }">
            </rappider-compiled-component-renderer>
          </div>

          <!-- Update Button -->
          <button class="ai-design-button ai-design-button-left"
                  nz-button
                  [nzType]="hasDisplayComponent() ? 'default' : 'primary'"
                  nzSize="large"
                  (click)="onGenerateCustomComponentWithAIButtonClicked()">
            <i class="fa-solid fa-sparkles ai-icon"></i> &nbsp; {{ getDesignButtonText() }}
          </button>

          <!-- Transform JSONata Config Viewer -->
          <nz-collapse *ngIf="transformJsonataConfig"
                      class="transform-config-collapse"
                      [nzBordered]="true"
                      [nzExpandIconPosition]="'right'">
            <nz-collapse-panel [nzActive]="false"
                              nzGhost
                              [nzHeader]="transformConfigHeader">
              <ng-template #transformConfigHeader>
                <div class="transform-config-header">
                  <i class="fa-regular fa-code transform-config-icon"></i>
                  <span class="transform-config-title">JSONata Configuration</span>
                </div>
              </ng-template>
              <div class="transform-config-content">
                <rappider-json-viewer [data]="transformJsonataConfig"
                                      [maxLineToDisplay]="100">
                </rappider-json-viewer>
              </div>
            </nz-collapse-panel>
          </nz-collapse>
          </section>
        </ng-container>

        <!-- No Component Template -->
        <ng-template #noComponentTemplate>
          <div class="custom-view-component-container">
            <!-- Start Icon -->
            <div class="ai-start-icon">
              <i class="fa-solid fa-sparkles ai-start-icon"></i>
            </div>

            <!-- Start Title -->
            <h2 class="ai-start-title">
              Design a Visual Element for {{entityConfig?.name ?? 'the'}} Entity Items
            </h2>

            <!-- Start Description -->
            <p class="ai-start-description">
              Design a visual element with AI Assistant for {{entityConfig?.name ?? 'the'}} Entity Items. AI will
              help you to design a custom component that will be used in the AI assistant and other detailed views.
              e.g.:
              you can create a beautiful card view for your entity items and when you ask the AI assistant to show the
              details of {{entityConfig?.name ?? 'an entity'}} item, it will use this custom component to display the
              item
              details.
            </p>


            <button class="ai-design-button"
                    nz-button
                    [nzType]="hasDisplayComponent() ? 'default' : 'primary'"
                    nzSize="large"
                    (click)="onGenerateCustomComponentWithAIButtonClicked()">
              <i class="fa-solid fa-sparkles ai-icon"></i> &nbsp; {{ getDesignButtonText() }}
            </button>
          </div>
        </ng-template>
      </nz-collapse-panel>

    </nz-collapse>
    <!-- GRID VIEW -->
    <nz-collapse *ngIf="displayedSection === 'all' || displayedSection === 'gridView'"
                 class="manage-entity-collapse"
                 [nzBordered]="true"
                 [nzExpandIconPosition]="'right'">

      <nz-collapse-panel class="manage-entity-collapse-panel"
                         [nzActive]="expandAllSections || displayedSection === 'gridView'"
                         [nzDisabled]="displayedSection !== 'all'"
                         nzGhost
                         [nzHeader]="nzCollapseHeader2">

        <ng-template #nzCollapseHeader2>
          <ng-container *ngTemplateOutlet="nzCollapseHeader;
                          context:{
                            title: 'Grid View (List)',
                            description: 'Define how multiple items of this entity are displayed in a grid or list format. Customize the layout, fields shown, and interaction options.',
                            key: 'gridView',
                            buttonTitle: 'Configure Grid View for ' + (entityConfig?.name ?? 'the') + ' Entity'
                          }"></ng-container>
        </ng-template>

        <!-- Example Data Alert -->
        <rappider-alert *ngIf="isExampleData && entityData && entityData.length > 0"
                        [type]="AlertTypes.Info"
                        [description]="{
                          text: 'The displayed data consists of example records for demonstration purposes. Editing and deleting operations are not available for example data. Once you add real data to your entity, these example records will be automatically replaced.'
                        }"
                        [showIcon]="true"
                        [closeable]="false"
                        [marginSettings]="{
                          bottom: 'var(--margin-4x)'
                        }">
        </rappider-alert>

        <section>
        <!-- Grid List -->
        <rappider-crud-view *ngIf="entityConfig?.config && activeEntityConfig"
                            [activeEntityConfig]="activeEntityConfig!"
                            [modelNameSingular]="entityConfig?.name"
                            [mainTitleConfig]="{ content: entityConfig?.name, type: 'h3' }"
                            [viewMode]="ViewMode.List"
                            [listMode]="ListMode.Grid"
                            [showCreateButton]="false"
                            [displayListModeRadioButtons]="false"
                            [displayToolbarBackButton]="false"
                            [listGridData]="entityData ?? []"
                            [listGridConfig]="entityConfig?.config?.listGridConfig"
                            [gridBuilderButton]="{
                              icon: { name: 'fa-regular fa-gear', type: IconType.FontAwesome },
                              text: 'Configure Table',
                              type: ButtonType.Primary,
                              tooltipText: 'Configure Table Settings'
                            }"
                            [cardListConfig]="entityConfig?.config?.cardListConfig"
                            [isListGridDataLoading]="isEntityDataLoading"
                            (gridBuilderConfigSaved)="onGridBuilderConfigSaved($event)"
                            (listGridVisibilityColumnsChanged)="onListGridVisibilityColumnsChanged($event)"
                            (cardListItemSelected)="onGridRowItemSelected($event)">
        </rappider-crud-view>
        </section>
        <!-- Loading State -->
        <ng-container *ngIf="!entityConfig?.config">
          <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
        </ng-container>

      </nz-collapse-panel>
    </nz-collapse>

    <nz-collapse *ngIf="displayedSection === 'all' || displayedSection === 'cardView'"
                 class="manage-entity-collapse"
                 [nzBordered]="true"
                 [nzExpandIconPosition]="'right'">

      <nz-collapse-panel class="manage-entity-collapse-panel"
                         [nzActive]="expandAllSections || displayedSection === 'cardView'"
                         [nzDisabled]="displayedSection !== 'all'"
                         nzGhost
                         [nzHeader]="nzCollapseHeader3">
        <ng-template #nzCollapseHeader3>
          <ng-container *ngTemplateOutlet="nzCollapseHeader;
                          context:{
                            title: 'Card View (List)',
                            description: 'Define how multiple items of this entity are displayed in a card or list format. Customize the layout, fields shown, and interaction options.',
                            key: 'cardView',
                            buttonTitle: 'Configure Card View for ' + (entityConfig?.name ?? 'the') + ' Entity'
                          }"></ng-container>
        </ng-template>
        <!-- Example Data Alert -->
        <rappider-alert *ngIf="isExampleData && entityData && entityData.length > 0"
                        [type]="AlertTypes.Info"
                        [description]="{
                          text: 'The displayed data consists of example records for demonstration purposes. Editing and deleting operations are not available for example data. Once you add real data to your entity, these example records will be automatically replaced.'
                        }"
                        [showIcon]="true"
                        [closeable]="false"
                        [marginSettings]="{
                          bottom: 'var(--margin-4x)'
                        }">
        </rappider-alert>

        <section>
        <!-- Card List -->
        <rappider-crud-view *ngIf="entityConfig?.config && activeEntityConfig"
                            [activeEntityConfig]="activeEntityConfig!"
                            [modelNameSingular]="entityConfig?.name"
                            [mainTitleConfig]="{ content: entityConfig?.name, type: 'h3' }"
                            [viewMode]="ViewMode.List"
                            [listMode]="ListMode.Card"
                            [showCreateButton]="false"
                            [displayListModeRadioButtons]="false"
                            [displayToolbarBackButton]="false"
                            [listGridData]="entityData ?? []"
                            [listGridConfig]="entityConfig?.config?.listGridConfig"
                            [cardListConfig]="entityConfig?.config?.cardListConfig"
                            [cardBuilderButton]="{
                              icon: { name: 'fa-regular fa-gear', type: IconType.FontAwesome },
                              text: 'Configure Card',
                              type: ButtonType.Primary,
                              tooltipText: 'Configure Card View Settings'
                            }"
                            [isListGridDataLoading]="isEntityDataLoading"
                            (cardBuilderConfigSaved)="onCardBuilderConfigSaved($event)"
                            (cardListItemSelected)="onGridRowItemSelected($event)">
        </rappider-crud-view>
        </section>
        <!-- Loading State -->
        <ng-container *ngIf="!entityConfig?.config">
          <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
        </ng-container>

        <!-- End of Card List -->
      </nz-collapse-panel>
    </nz-collapse>

    <nz-collapse *ngIf="displayedSection === 'all' || displayedSection === 'itemDataView'"
                 class="manage-entity-collapse"
                 [nzBordered]="true"
                 [nzExpandIconPosition]="'right'">

      <nz-collapse-panel #itemDataViewPanel
                         class="manage-entity-collapse-panel"
                         [nzActive]="expandAllSections || displayedSection === 'itemDataView'"
                         [nzDisabled]="displayedSection !== 'all'"
                         nzGhost
                         [nzHeader]="nzCollapseHeader4">
        <ng-template #nzCollapseHeader4>
          <ng-container *ngTemplateOutlet="nzCollapseHeader;
                          context:{
                            title: 'Item Data View',
                            description: 'Define how individual items of this entity are displayed in detail. Customize the layout, fields shown, and interaction options.',
                            key: 'itemDataView',
                            buttonTitle: 'Configure Item Data View for ' + (entityConfig?.name ?? 'the') + ' Entity'
                          }"></ng-container>
        </ng-template>

        <!-- Example Data Alert -->
        <rappider-alert *ngIf="isExampleData && entityData && entityData.length > 0"
                        [type]="AlertTypes.Info"
                        [description]="{
                          text: 'The displayed data consists of example records for demonstration purposes. Editing and deleting operations are not available for example data. Once you add real data to your entity, these example records will be automatically replaced.'
                        }"
                        [showIcon]="true"
                        [closeable]="false"
                        [marginSettings]="{
                          bottom: 'var(--margin-4x)'
                        }">
        </rappider-alert>

        <section>
        <!-- Detail View -->
        <rappider-crud-view #itemDataViewCrudView
                            *ngIf="entityConfig?.config && activeEntityConfig"
                            [activeEntityConfig]="activeEntityConfig!"
                            [modelNameSingular]="entityConfig?.name"
                            [mainTitleConfig]="{ content: entityConfig?.name, type: 'h3' }"
                            [viewMode]="ViewMode.Detail"
                            [listMode]="ListMode.Grid"
                            [showCreateButton]="false"
                            [displayListModeRadioButtons]="false"
                            [displayToolbarBackButton]="false"
                            [listGridData]="entityData ?? []"
                            [listGridConfig]="entityConfig?.config?.listGridConfig"
                            [cardListConfig]="entityConfig?.config?.cardListConfig"
                            [createFormConfig]="entityConfig?.config?.createItemFormConfig"
                            [updateFormConfig]="entityConfig?.config?.updateItemFormConfig"
                            [detailViewConfig]="entityConfig?.config?.detailViewConfig"
                            [itemDataBuilderButton]="{
                              icon: { name: 'fa-regular fa-gear', type: IconType.FontAwesome },
                              text: 'Configure Item Data View',
                              type: ButtonType.Primary,
                              tooltipText: 'Configure Item Data View Settings'
                            }"
                            [activeItem]="getSelectedItemForDetailView()"
                            [isListGridDataLoading]="isEntityDataLoading"
                            (itemDataBuilderConfigSaved)="onItemDataBuilderConfigSaved($event)"
                            (cardListItemSelected)="onItemDataViewGridRowItemSelected($event)">
        </rappider-crud-view>
        </section>
        <!-- Loading State -->
        <ng-container *ngIf="!entityConfig?.config">
          <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
        </ng-container>
      </nz-collapse-panel>

    </nz-collapse>

    <nz-collapse *ngIf="displayedSection === 'all' || displayedSection === 'itemEditView'"
                 class="manage-entity-collapse"
                 [nzBordered]="true"
                 [nzExpandIconPosition]="'right'">

      <nz-collapse-panel class="manage-entity-collapse-panel"
                         [nzActive]="expandAllSections || displayedSection === 'itemEditView'"
                         [nzDisabled]="displayedSection !== 'all'"
                         nzGhost
                         [nzHeader]="nzCollapseHeader5">
        <ng-template #nzCollapseHeader5>
          <ng-container *ngTemplateOutlet="nzCollapseHeader;
                          context:{
                            title: 'Edit View (Entity Item)',
                            description: 'Edit the details of an individual entity item. Customize the layout, fields, and interactions for updating existing records in your data model.',
                            key: 'itemEditView',
                            buttonTitle: 'Configure Edit View for ' + (entityConfig?.name ?? 'the') + ' Entity'
                          }"></ng-container>
        </ng-template>

        <!-- Item Edit View -->
        <rappider-crud-view *ngIf="entityConfig?.config"
                            [modelNameSingular]="entityConfig?.name"
                            [mainTitleConfig]="{ content: entityConfig?.name, type: 'h3' }"
                            [viewMode]="ViewMode.Edit"
                            [listMode]="ListMode.Grid"
                            [showCreateButton]="false"
                            [displayListModeRadioButtons]="false"
                            [displayToolbarBackButton]="false"
                            [listGridData]="entityData ?? []"
                            [listGridConfig]="entityConfig?.config?.listGridConfig"
                            [cardListConfig]="entityConfig?.config?.cardListConfig"
                            [createFormConfig]="entityConfig?.config?.createItemFormConfig"
                            [updateFormConfig]="entityConfig?.config?.updateItemFormConfig"
                            [activeItem]="entityData && entityData.length ? entityData[0] : undefined"
                            [isListGridDataLoading]="isEntityDataLoading"
                            [showFormBuilderButton]="true"
                            (formBuilderConfigSaved)="onFormBuilderConfigSaved($event)">
        </rappider-crud-view>

        <!-- Loading State -->
        <ng-container *ngIf="!entityConfig?.config">
          <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
        </ng-container>
      </nz-collapse-panel>

    </nz-collapse>

    <nz-collapse *ngIf="displayedSection === 'all' || displayedSection === 'itemCreateView'"
                 class="manage-entity-collapse"
                 [nzBordered]="true"
                 [nzExpandIconPosition]="'right'">

      <nz-collapse-panel class="manage-entity-collapse-panel"
                         [nzActive]="expandAllSections || displayedSection === 'itemCreateView'"
                         [nzDisabled]="displayedSection !== 'all'"
                         nzGhost
                         [nzHeader]="nzCollapseHeader6">
        <ng-template #nzCollapseHeader6>
          <ng-container *ngTemplateOutlet="nzCollapseHeader;
                          context:{
                            title: 'Create View (Entity Item)',
                            description: 'Create a new entity item. Customize the layout, fields, and interactions for adding new records to your data model.',
                            key: 'itemCreateView',
                            buttonTitle: 'Configure Create View for ' + (entityConfig?.name ?? 'the') + ' Entity'
                          }"></ng-container>
        </ng-template>

        <!-- Item Create View -->
        <rappider-crud-view *ngIf="entityConfig?.config"
                            [modelNameSingular]="entityConfig?.name"
                            [mainTitleConfig]="{ content: entityConfig?.name, type: 'h3' }"
                            [viewMode]="ViewMode.Create"
                            [listMode]="ListMode.Grid"
                            [showCreateButton]="false"
                            [displayListModeRadioButtons]="false"
                            [displayToolbarBackButton]="false"
                            [listGridData]="entityData ?? []"
                            [listGridConfig]="entityConfig?.config?.listGridConfig"
                            [cardListConfig]="entityConfig?.config?.cardListConfig"
                            [createFormConfig]="entityConfig?.config?.createItemFormConfig"
                            [updateFormConfig]="entityConfig?.config?.updateItemFormConfig"
                            [activeItem]="entityData && entityData.length ? entityData[0] : undefined"
                            [isListGridDataLoading]="isEntityDataLoading"
                            [showFormBuilderButton]="true"
                            (formBuilderConfigSaved)="onFormBuilderConfigSaved($event)">
        </rappider-crud-view>

        <!-- Loading State -->
        <ng-container *ngIf="!entityConfig?.config">
          <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
        </ng-container>
      </nz-collapse-panel>

    </nz-collapse>

    <nz-collapse *ngIf="displayedSection === 'all' || displayedSection === 'schemaView'"
                 class="manage-entity-collapse"
                 [nzBordered]="true"
                 [nzExpandIconPosition]="'right'">

      <nz-collapse-panel class="manage-entity-collapse-panel"
                         [nzActive]="expandAllSections || displayedSection === 'schemaView'"
                         [nzDisabled]="displayedSection !== 'all'"
                         nzGhost
                         [nzHeader]="nzCollapseHeader1">

        <ng-template #nzCollapseHeader1>
          <ng-container *ngTemplateOutlet="nzCollapseHeader;
                          context:{
                            title: 'Entity Schema',
                            description: 'Definition and the fields of this entity. Visual components will use this schema and description to visualize and interact with the entity items.',
                            key: 'entitySchema',
                            buttonTitle: 'Navigate to Data Model Editor'
                          }"></ng-container>
        </ng-template>

        <rappider-data-model-display-with-fields [projectModel]="selectedProjectModel"
                                                 [animateTable]="true"></rappider-data-model-display-with-fields>

        <!-- Loading State -->
        <ng-container *ngIf="!selectedProjectModel">
          <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
        </ng-container>

      </nz-collapse-panel>
    </nz-collapse>

    <nz-collapse *ngIf="false"
                 class="manage-entity-collapse"
                 [nzBordered]="true"
                 [nzExpandIconPosition]="'right'">



      <nz-collapse-panel class="manage-entity-collapse-panel"
                         nzActive="false"
                         nzGhost
                         [nzHeader]="nzCollapseHeader7">
        <ng-template #nzCollapseHeader7>
          <ng-container *ngTemplateOutlet="nzCollapseHeader;
                          context:{
                            title: 'Debug Panel',
                            description: 'Inspect the current state of the selected project model.'
                          }"></ng-container>
        </ng-template>
        <pre>
          {{ selectedProjectModel | json }}
        </pre>
      </nz-collapse-panel>

    </nz-collapse>


  </div>


</div>

<ng-template #nzCollapseHeader
             let-title="title"
             let-description="description"
             let-key="key"
             let-buttonTitle="buttonTitle">
  <div class="collapse-header-container">
    <h4 class="p-2x title">{{title}}</h4>
    <p class="title-description">
      {{description}}
    </p>
    <!-- <div *ngIf="key"
         class="collapse-header-actions">
      <rappider-button
        [text]="buttonTitle ?? 'Configure'"
        type="default"
        [icon]="{ name: 'fa-regular fa-square-sliders' }"
        (confirm)="onCollapseHeaderActionButtonClicked($event, key)">
      </rappider-button>
    </div> -->
  </div>
</ng-template>


<ng-template #loadingTemplate>
  <nz-skeleton [nzAvatar]="false"
               [nzTitle]="true"
               [nzParagraph]="{ rows: 3 }"></nz-skeleton>
</ng-template>
